import React from "react"
import {FieldViewProps} from "../../../../render/view";

// const debug = "FieldExpenseReimbursement_ViewSmall"
const debug = false

export default class FieldExpenseReimbursement_ViewSmall extends React.Component<FieldViewProps, any> {

    constructor(props:FieldViewProps) {
        super(props)

        this.state = {
            isHovered: false,
            showPopover: false
        }
    }

    render() {
        const reimbursement = this.props.model.reimbursementStatus
        const reimbursementOption = this.props.field.options?.find((option: Option)=>option.value === reimbursement)

        return (
            <div className={Classes(this.props.className)}>
                <div
                    className={Classes('ui5-status-list', 'status-c{0}'.f(reimbursementOption?.color), this.props.className)}>
                    <div className="max-w-100-percent txt-truncate">{reimbursementOption?.label}</div>
                </div>
            </div>
        )
    }
}



